import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';

import Message from '@components/Share/Message';
import { login } from '@redux/actions/singleSignOn';
import { Link, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import global from '@utils/global';

import { useDisplayFormikMessage } from '../../../hooks/useDisplayFormikMessage';
import { useScheduleAppointmentContext } from '../../../hooks/useScheduleAppointmentContext';

const LoginForm = ({ error, isLoginSuccess }) => {
  const dispatch = useDispatch();
  const displayErrorMessage = useDisplayFormikMessage();
  const { layoutData } = useScheduleAppointmentContext();

  const formik = useFormik({
    initialValues: {
      emailLogin: '',
      passwordLogin: ''
    },
    validationSchema: Yup.object({
      passwordLogin: Yup.string()
        .required(<Message messageCode='Msg_001.5' />)
        .trim(),
      // .matches(global.formatPassword(MINUMUM_CHARACTERS_PASSWORD), <Message messageCode='Msg_001.5' />),
      emailLogin: Yup.string()
        .email(<Message messageCode='Msg_001.3' />)
        .required(<Message messageCode='Msg_001.3' />)
        .trim()
    }),
    onSubmit: (values) => {
      dispatch(
        login({
          UserName: values.emailLogin,
          PassWord: values.passwordLogin
        })
      );
    },
    validateOnMount: true
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className='form-group'>
        {error?.errorMessage && !isLoginSuccess ? (
          <span className='error-validate'>
            {error === 'Failed' ? <Message messageCode='Msg_003' /> : <RichText field={{ value: error.errorMessage }} />}
          </span>
        ) : (
          ''
        )}
      </div>
      <div className={global.renderDynamicClass(formik.errors.emailLogin && formik.touched.emailLogin, 'form-group', 'input-error-validate')}>
        <input
          onChange={formik.handleChange}
          value={formik.values.emailLogin}
          type='text'
          id='emailLogin'
          className={global.renderDynamicClass(formik.values['emailLogin'], 'form-control form-control-lg', 'input-valid')}
          name='emailLogin'
          placeholder={layoutData?.['Email']?.value}
        />
        <label htmlFor='emailLogin' className='form-group__label'>
          <Text field={layoutData?.['Email']} />
        </label>
        <span className='error-validate'>{displayErrorMessage(formik, 'emailLogin')}</span>
      </div>
      <div className={global.renderDynamicClass(formik.errors.passwordLogin && formik.touched.passwordLogin, 'form-group', 'input-error-validate')}>
        <input
          onChange={formik.handleChange}
          value={formik.values.passwordLogin}
          type='password'
          className={global.renderDynamicClass(formik.values['passwordLogin'], 'form-control form-control-lg', 'input-valid')}
          id='passwordLogin'
          placeholder={layoutData?.['Password Text']?.value}
          autoComplete='off'
        />
        <label htmlFor='passwordLogin' className='form-group__label'>
          <Text field={layoutData?.['Password Text']} />
        </label>
        <span className='error-validate'>{displayErrorMessage(formik, 'passwordLogin')}</span>
      </div>
      <div className='form-group osim-account-form__form__forgot-pass text-right'>
        <Link field={layoutData['Forgot Password Link']}>
          <Text field={layoutData?.['Forgot Password Text']} />
        </Link>
      </div>
      <div className='form-group osim-account-form__form__btn'>
        <button className='osim-account-form__form__btn__item btn btn-primary'>
          <Text field={layoutData?.['Login Button Text']} />
        </button>
      </div>
    </form>
  );
};

LoginForm.propTypes = {
  error: PropTypes.any,
  isLoginSuccess: PropTypes.bool
};

const mapStateToProps = (state) => ({
  isLoginSuccess: state.singleSignOnReducer.userInfoReducer?.isLogin,
  error: state.singleSignOnReducer.loginReducer?.error
});

export default connect(mapStateToProps)(LoginForm);
